import styled, { css } from 'styled-components'
import { clamp } from '../../styles/utils/conversion.style'
import { flow } from '../../styles/utils/functions.style'
import { easings } from '../../styles/vars/easings.style'

export const RichTextMain = styled.div`
  ${flow()}

  table {
    ${clamp('font-size', 14, 18)};
  }
`

const listStyles = css``

export const UnorderedList = styled.ul`
  ${listStyles}
  list-style: disc;
  padding-left: 2rem;

  li > * {
    margin-top: 0.5em;
  }
`

export const OrderedList = styled.ol`
  ${listStyles}
  list-style: none;
`

export const ListItem = styled.li`
  & + & {
    margin-top: 0.5em;
  }

  p {
    padding-bottom: 0;
    position: relative;
    padding-left: 0.75em;

    :before {
      content: '';
      position: absolute;
      top: 0.6em;
      left: 0;
      transform: translateY(1rem);
      display: block;
      width: 0.3rem;
      height: 0.3rem;
      overflow: hidden;
      border-radius: 50%;
      background-color: currentColor;
      opacity: 0;
      transition: transform 0.5s ${easings.inOut.default},
        opacity 0.5s ${easings.inOut.default};
      transition-delay: ${props => `${props.delay}s`};
      will-change: transform, opacity;

      [data-inview='true'] & {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
`
